import React from 'react';
import { withTheme } from 'styled-components';
import MaterialIcon from 'material-icons-react';

import {
  StepCheck,
  StepLabel,
  StepCircle,
  StepContain,
  IconContain,
  StepperBarFill,
  StepperContain,
  StepperBarContain
} from './StepperStyled';

export const Stepper = ({ children, step }) => {
  return (
    <React.Fragment>
      <StepperContain>
        {React.Children.map(children, (child, index) =>
          React.cloneElement(child, {
            current: child.props.completeStep !== undefined 
              ? child.props.completeStep >= step
              : index === step,
            complete: child.props.completeStep !== undefined 
              ? child.props.completeStep < step
              : index < step,
            index
          })
        )}
      </StepperContain>
      <StepperBarContain>
        <StepperBarFill percent={(step / children.length) * 100} />
      </StepperBarContain>
    </React.Fragment>
  );
};

export const Step = withTheme(({ hidden, label, theme, current, complete }) => {
  return (
    <StepContain hidden={hidden} complete={complete} current={current}>
      <StepCircle complete={complete} current={current}>
        {complete && (
          <IconContain>
            <MaterialIcon icon="done" color={'rgb(67, 170, 172)'} size={32} />
          </IconContain>
        )}
        {!complete && current && <StepCheck />}
      </StepCircle>
      <StepLabel>{label}</StepLabel>
    </StepContain>
  );
});

export default Stepper;
